// Mặc định `ng serve` / `ng build`: môi trường **local** (xem environment.local.ts).
// Build hosted: `ng build --configuration=dev` | `--configuration=production`
// Hoặc: `FRONTEND_BUILD_ENV=local|dev|prod ./scripts/ng-build-env.sh`
export { environment } from "./environment.local";
